// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
var inject = allVue.inject;
import { provideIntlService } from '@progress/kendo-vue-intl';
import { getTemplate } from '@progress/kendo-vue-common';
/**
 * @hidden
 */
var DateHeaderCellVue2 = {
  name: 'KendoDateHeaderCell',
  props: {
    as: [String, Function, Object],
    format: {
      type: [String, Object],
      default: 'd'
    },
    date: [Date, Object],
    start: Date,
    end: Date
  },
  inject: {
    kendoIntlService: {
      default: null
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    var kendoIntlService = inject('kendoIntlService', {});
    return {
      v3: v3,
      kendoIntlService: kendoIntlService
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var intl = provideIntlService(this);
    var renderAs;
    var defaultRendering = intl.formatDate(this.$props.date, this.$props.format);
    renderAs = getTemplate.call(this, {
      h: h,
      template: this.$props.as,
      defaultRendering: defaultRendering,
      additionalProps: {
        default: defaultRendering,
        date: this.$props.date,
        format: this.$props.format
      }
    });
    return h("div", {
      "class": 'k-scheduler-cell k-heading-cell'
    }, [h("span", {
      "class": "k-link k-nav-day"
    }, [renderAs])]);
  }
};
/**
 * @hidden
 */
var DateHeaderCell = DateHeaderCellVue2;
export { DateHeaderCell, DateHeaderCellVue2 };